import Swal from 'sweetalert2';
import { CgSpinner } from 'react-icons/cg';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import { CUSTOM_EVENTS } from '../../../../utils/constants';
import { objectToFormData } from '../../../../utils/utils';
import React, { useEffect, useState } from 'react';
import { Button, DialogActions, Divider, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { useAppointmentDetailsContext } from '../contexts/appointmentdetails.context';
import PropTypes from 'prop-types';

const ReportsSelection = ({setReport}) => {
    const { appointmentDetails } = useAppointmentDetailsContext();
    const [fetching, setFetching] = useState(false);
    const [reports, setReports] = useState([]);
    const [selectedReport, setSelectedReport] = useState('');

    const handleChange = (event) => {
        setSelectedReport(event.target.value);
        setReport(event.target.value);
    };

    const apptId = appointmentDetails && appointmentDetails.id;
    useEffect(() => {
        const fetchReports = async () => {
            if (!apptId) return;
            const url = APIUtils.getAPIEndpoint('myappointment-reports');
            setFetching(true);
            const res = await httpClient.get(`${url}/${apptId}`).then(res => res.data);
            if (res.status === 'success') {
                setReports(res.data);
            } else {
                Swal.fire('Something Went Wrong!', '', 'error');
            }
            setFetching(false);
        };

        // document.addEventListener(CUSTOM_EVENTS.REFECTH_REPORTS, fetchReports);
        fetchReports();

        return () => {
            // document.removeEventListener(CUSTOM_EVENTS.REFECTH_REPORTS, fetchReports);
        };
    }, [apptId]);

    const loadingReports = fetching && <Typography variant="caption" gutterBottom style={{fontWeight: 'bold'}}>Fetching Reports<span className="ellipsis-loading"></span></Typography>;

    const reportItems = reports.map(report => <MenuItem key={report.id} value={report.id}>{report.name}</MenuItem>);
    return (
        <div className='report-selection-option'>
            <Typography variant="subtitle1" gutterBottom>
                For Report (Optional) {loadingReports}
            </Typography>
            <FormControl fullWidth>
                <InputLabel>Select Report</InputLabel>
                <Select
                    value={selectedReport}
                    label="Select Report"
                    onChange={handleChange}
                >
                    {reportItems}
                </Select>
            </FormControl>
        </div>
    );
};

function PrescriptionDialog() {
    const { appointmentDetails: appointment } = useAppointmentDetailsContext();
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [report, setReport] = useState('');

    const handlePrescription = (e) => {
        const fileData = e.target.files[0];
        setFile(fileData);
    };

    const handleUploadPrescription = async () => {
        const url = APIUtils.getAdminAPIEndpoint('upload-prescription');
        const filename = file.name.replace(/\.[^/.]+$/, '').replace(/[^a-zA-Z0-9\s]/g, '');
        const formData = objectToFormData({ prescription: file, apptID: appointment.id, reportID: report, name: filename });
        setUploading(true);
        try {
            const res = await httpClient.post(url, formData).then(res => res.data);
            if (res.status === 'success') {
                Swal.fire('Status!', 'Prescription uploaded successfully!', 'success');
                // Close Prescription Dialog
                document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.TOGGLE_PRESCRIPTION_DIALOG, { detail: false }));
                // Fetch prescriptions list
                document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.REFECTH_REPORTS));
            }
            // else {
            //     Swal.fire('Something Went Wrong!', '', 'error');
            // }
        } catch (error) {
            Swal.fire('Something Went Wrong!', '', 'error');
        }
        setUploading(false);
    };

    const selectedFileName = file && file.name;

    const uploadBtn = (
        <>
            <div className='flex-gap'>
                <Button variant='outlined' component='label'>
                    <input
                        type='file'
                        accept='image/png, application/pdf, image/jpeg'
                        hidden={true}
                        onChange={handlePrescription}
                    />
                    Browse Prescription
                </Button>
                <p className='text-ellipsis' title={selectedFileName}>{selectedFileName}</p>
            </div>
            <Divider>OR</Divider>
            <div className='flex-gap'>
                <Button variant='outlined' component='label'>
                    <input
                        type='file'
                        accept="image/*"
                        capture="environment"
                        hidden={true}
                        onChange={handlePrescription}
                    />
                    Capture Photo (Mobile Only)
                </Button>
                <p className='text-ellipsis' title={selectedFileName}>{selectedFileName}</p>
            </div>
            {/* <Divider className='m-top' /> */}
            <ReportsSelection setReport={setReport} />
        </>
    );

    const uploadingUI = () => {
        if (uploading) {
            return <>
                Uploading...&nbsp;<CgSpinner size={20} className='mt-1 animate-spin' />
            </>;
        }
        return <>Upload</>;
    };

    const btnDisabled = !file || uploading;

    return  (
        <>
            {uploadBtn}
            <DialogActions>
                <Button variant='contained' color='primary' disabled={btnDisabled} onClick={handleUploadPrescription}>
                    {uploadingUI()}
                </Button>
            </DialogActions>
        </>
    );
}

export default PrescriptionDialog;

ReportsSelection.propTypes = {
    setReport: PropTypes.func.isRequired,
};